import { translations as frTranslations } from './fr';

const languageMap = {
  fr_FR: frTranslations,
};

export const i18n = languageMap['fr_FR'];
